import { useEffect, useState } from "react";
import LeftArrowIcon from "../Components/leftArrowIcon";
import RightArrowIcon from "../Components/rightArrowIcon";
import "../Static Files/styles/Slider/slider.css";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTour } from "../slices/tourSlice";

const ImageSlider = ({ tours }) => {
  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = 4; // Hər dəfə göstəriləcək kart sayı

  // Tur sayı 4-dən azdırsa, hamısını göstər
  if (tours.length <= itemsPerPage) {
    return (
      <div className="lists">
        <ul>
          {tours.map((tour, index) => (
            <li key={index}>
              <TourCard tour={tour} />
              
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const nextSlide = () => {
    setStartIndex((prevIndex) => (prevIndex + 1) % tours.length);
  };

  const prevSlide = () => {
    setStartIndex((prevIndex) =>
      prevIndex === 0 ? tours.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="lists">
      <button onClick={prevSlide} className="left-arrow-icon">
        <LeftArrowIcon />
      </button>

      <ul className="tours-ul">
        {Array.from({ length: itemsPerPage }).map((_, i) => {
          const index = (startIndex + i) % tours.length;
          return (
            <li className="tours-li" key={index}>
              <TourCard tour={tours[index]} />
            </li>
          );
        })}
      </ul>

      <button onClick={nextSlide} className="right-arrow-icon">
        <RightArrowIcon />
      </button>
    </div>
  );
};

const TourCard = ({ tour }) => {
  // `description`u qısaltma funksiyası
  const shortDescription =
    tour.description.length > 30
      ? `${tour.description.substring(0, 30)}...`
      : tour.description;

  const location = useLocation();

  const lang = location.pathname.split("/")[1];



  return (
    <div className="tours-card">
      <div className="card-img">
        {tour.isSpecialOffer === true && (
          <div className="special-offer">Special Offer</div>
        )}
        {tour.hasDiscount === true && (
          <div className="special-offer">Endirimli tur</div>
        )}
        {tour.tourGalleries.length > 0 && (
          <Link to={`/${lang}/tour/${tour.slug}`}>
            <img src={tour.headerImageUrl} alt="tour" />
          </Link>
        )}
      </div>
      <div className="card-text">
        <div className="country">
          <h4>{tour.title}</h4>
        </div>
        <h1>{shortDescription}</h1>
        <div className="price">
          from{" "}
          <span>
            {tour.currency === "USD" && "$"}
            {tour.currency === "EUR" && "€"}
            {tour.currency === "AZN" && "₼"}
            {tour.hasDiscount ? tour.discountPrice : tour.price}
          </span>{" "}
          {tour.hasDiscount && (
            <h6 className="discount-price-for-home">{tour.price}</h6>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
